import { getConfig } from '@constants';

import { Log } from '@utils';

export const counters = {
	// Отправка рб-счетчиков (зеропиксель).
	// @link https://confluence.mail.ru/display/WIKI/Pixel
	sendRB: (...counters: number[]) => {
		const prefix = 'd';

		for (const counter of counters) {
			const image = new Image();
			const mark = !counter.toString().startsWith('d') ? prefix + counter : counter.toString();

			image.onerror = () => {
				Log.error(`Couldn't send the counter ${counter}`);
			};

			image.src = location.protocol + `//${getConfig()?.hosts?.rb}/` + mark + '.gif?' + Math.random();
		}
	},
	// Возвращает ссылку с РБ счётчиком
	// url - полный путь с протоколом
	getRbUrl: (url: string, counter: number): string => {
		const rbUrl = url.replace(/\:\/\//, `://${getConfig()?.hosts?.rb || ''}/clr${counter}/`);

		return `${rbUrl}/?${Math.random()}`;
	},
	sendGrStat: (counters: string[] | string) => {
		const random = Math.random();
		if (!Array.isArray(counters)) {
			counters = [counters];
		}

		for (let i = 0; i < counters.length; i += 1) {
			(new Image()).src = '//my.mail.ru/grstat?name=' + counters[i] + '&r=' + random;
		}
	},
};
